import { axiosDS } from '@pp/axios'
import { ResponseCatalog, RequestParams } from 'Models'
import { SimpleResponse } from 'Types/simpleResponse'
import { StatsTasks, TaskModels } from 'Modules'
import { urls } from 'Src/constants/Urls'

export const taskModelApi = {
	getTasks: async (params: { data?: RequestParams; order_ids?: number[] }) => {
		const res = await axiosDS().get<ResponseCatalog<TaskModels>>(urls.order_tasks.index, { params })
		return res.data
	},
	setCompletedStatusTask: async ({ id, source }) => {
		const res = await axiosDS().patch<TaskModels>(
			urls.order_tasks.complete.replace(':id', id.toString()),
			{ source }
		)
		return res.data
	},
	setCreatedStatusTask: async (id: string) => {
		const res = await axiosDS().patch<TaskModels>(
			urls.order_tasks.revert_complete.replace(':id', id)
		)
		return res.data
	},
	getStatsTasks: async (params?: { period: string }) => {
		const res = await axiosDS().get<StatsTasks>(urls.order_tasks.stats, { params })
		return res.data
	},
	showedTaskTraining: async () => {
		const res = await axiosDS().patch<SimpleResponse>(urls.order_tasks.training_showed)
		return res.data
	},
	clickedTaskModelLogo: async () => {
		const res = await axiosDS().patch<SimpleResponse>(urls.order_tasks.task_model_logo_clicked)
		return res.data
	},
}
